import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import {
  CreateTagPayload,
  TagApiResponse,
  UpdateTagPayload,
} from 'src/types/tag';
import { ApiResponse, PaginatedResponse } from 'src/types/commonResponseTypes';
import { handleError } from 'src/utils/commonErrorUtils';

export const fetchTags = async (
  page: number,
  limit: number,
  search: string | null = null,
): Promise<ApiResponse<PaginatedResponse<TagApiResponse[]>>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getTags'](page, limit, search);
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const createTag = async (
  body: CreateTagPayload,
): Promise<ApiResponse<TagApiResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['createTag']();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const updateTagById = async (
  tagId: string,
  body: UpdateTagPayload,
): Promise<ApiResponse<TagApiResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['updateTagById'](tagId);
    const { data } = await axiosInstance.patch(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const deleteTagById = async (
  tagId: string,
): Promise<ApiResponse<TagApiResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['deleteTagById'](tagId);
    const { data } = await axiosInstance.delete(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
